"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseUrlFromConfig = exports.URI = void 0;
var browser_1 = require("@cian/config/browser");
var shared_1 = require("../../../shared");
var helpers_1 = require("../../../shared/URI/helpers");
var parsers_1 = require("../../../shared/URI/parsers");
var wordsCase_1 = require("../../../shared/internal/wordsCase/wordsCase");
var browser_2 = require("@cian/logger/browser");
var URI = /** @class */ (function () {
    function URI(params) {
        this.model = params.model;
        this.subdomain = params.subdomain;
        this.transformBodyToLegacyString = params.transformBodyToLegacyString;
        var config = (0, browser_1.getConfig)();
        this.parsedURI = (0, parsers_1.parseURI)(getBaseUrlFromConfig(config, this.model));
    }
    Object.defineProperty(URI.prototype, "scheme", {
        get: function () {
            return this.parsedURI.scheme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URI.prototype, "host", {
        get: function () {
            if (this.subdomain) {
                return "".concat(this.subdomain, ".").concat(this.parsedURI.host);
            }
            return this.parsedURI.host;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URI.prototype, "port", {
        get: function () {
            return this.parsedURI.port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URI.prototype, "path", {
        get: function () {
            return (0, shared_1.mergePaths)(this.parsedURI.path, this.model.pathApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(URI.prototype, "query", {
        get: function () {
            var _a = this.model, method = _a.method, parameters = _a.parameters;
            if (method !== 'GET' || !parameters) {
                return undefined;
            }
            return (0, helpers_1.transformObjectToQuery)(parameters, this.transformBodyToLegacyString);
        },
        enumerable: false,
        configurable: true
    });
    return URI;
}());
exports.URI = URI;
function getBaseUrlFromConfig(config, model) {
    if (model.apiType === 'external') {
        return config.getStrict("".concat(model.microserviceName, ".externalUrl"));
    }
    var _a = model.hostType, hostType = _a === void 0 ? 'api' : _a, microserviceName = model.microserviceName;
    var mcsRunEnvType = config.get('mcsRunEnvType');
    var hostPart = hostType === 'ud-api' ? 'udApiBrowserUrl' : 'browserUrl';
    var baseServiceUri = config.get("".concat(microserviceName, ".").concat(hostPart));
    if (baseServiceUri) {
        if (process.env.NODE_ENV === 'development') {
            var microserviceNameKebabCase_1 = (0, wordsCase_1.camelCaseToKebabCase)(microserviceName);
            if (!config.get("".concat(microserviceNameKebabCase_1, ".").concat(hostPart))) {
                var logger = (0, browser_2.getLogger)();
                logger.warning("\u0412 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0435 \"".concat(microserviceName, ".").concat(hostPart, "\" \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430\u044F \u043D\u043E\u0442\u0430\u0446\u0438\u044F \u0434\u043B\u044F \u0438\u043C\u0435\u043D\u0438 \u043C\u0438\u043A\u0440\u043E\u0441\u0435\u0440\u0432\u0438\u0441\u0430"));
                logger.warning("\u0418\u043C\u044F \u043C\u0438\u043A\u0440\u043E\u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0432 kebab-case: \"".concat(microserviceNameKebabCase_1, ".").concat(hostPart, "\""));
            }
        }
        return baseServiceUri;
    }
    var microserviceNameCamelCase = (0, wordsCase_1.kebabCaseToCamelCase)(microserviceName);
    baseServiceUri = config.get("".concat(microserviceNameCamelCase, ".").concat(hostPart));
    if (baseServiceUri) {
        if (process.env.NODE_ENV === 'development') {
            var logger = (0, browser_2.getLogger)();
            var microserviceNameKebabCase_2 = (0, wordsCase_1.camelCaseToKebabCase)(microserviceName);
            logger.warning("\u0412 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0435 \"".concat(microserviceNameCamelCase, ".").concat(hostPart, "\" \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430\u044F \u043D\u043E\u0442\u0430\u0446\u0438\u044F \u0434\u043B\u044F \u0438\u043C\u0435\u043D\u0438 \u043C\u0438\u043A\u0440\u043E\u0441\u0435\u0440\u0432\u0438\u0441\u0430\n"));
            logger.warning("\u0418\u043C\u044F \u043C\u0438\u043A\u0440\u043E\u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0432 kebab-case: \"".concat(microserviceNameKebabCase_2, ".").concat(hostPart, "\""));
        }
        return baseServiceUri;
    }
    var microserviceNameKebabCase = (0, wordsCase_1.camelCaseToKebabCase)(microserviceName);
    if (model.apiType === 'legacy') {
        return config.getStrict("".concat(microserviceNameKebabCase, ".").concat(hostPart));
    }
    var mcsRunEnv = config.getStrict('mcsRunEnv');
    if (process.env.NODE_ENV === 'development') {
        if (microserviceNameKebabCase !== microserviceName && !(0, wordsCase_1.isLowerCase)(microserviceName)) {
            (0, browser_2.getLogger)().warning("\u0412 \u043C\u043E\u0434\u0435\u043B\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430\u044F \u043D\u043E\u0442\u0430\u0446\u0438\u044F \u0434\u043B\u044F \u0438\u043C\u0435\u043D\u0438 \u043C\u0438\u043A\u0440\u043E\u0441\u0435\u0440\u0432\u0438\u0441\u0430.\n" +
                "\u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0438\u043C\u044F: \"".concat(microserviceName, "\", \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0435: ").concat(microserviceNameKebabCase));
        }
    }
    switch (mcsRunEnvType) {
        case 'dev':
        case 'local':
            return "https://master.api.dev3.cian.ru/".concat(microserviceNameKebabCase, "/");
        case 'beta':
            return "https://api.".concat(mcsRunEnv.replace('-', ''), ".stage.cian.ru/").concat(microserviceNameKebabCase, "/");
        default:
            return "https://".concat(hostType, ".cian.ru/").concat(microserviceNameKebabCase, "/");
    }
}
exports.getBaseUrlFromConfig = getBaseUrlFromConfig;
//# sourceMappingURL=URI.js.map